import React from "react"

export default function Door() {
  return (
    <symbol id="svg-door" viewBox="0 0 32 32">
      <path
        fill="currentColor"
        d="M21.2 5V3.7l-14 1.5v23.1h17.6V5h-3.6zM20 5v22.1H8.3V6.2L20 5zm3.6 1.1v21h-2.5v-21h2.5zm-6.1 11.3c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5-1.5.7-1.5 1.5.7 1.5 1.5 1.5zm-.4-1.5c0-.2.2-.3.3-.3.2 0 .3.2.3.3s-.2.3-.3.3-.3-.1-.3-.3z"
      />
    </symbol>
  )
}
